// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Image/app-bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-white: #fff;
    --primary-black: #000;
    --primary-grey: #73739a;
    --primary-grey2: #f5f5f5;
    --primary-blue: #6d72f6;
    --primary-green: #08ce8a;
    --primary-black2: #1c1c57;
}




.RechargeApplication-section{
    padding: 3rem 0px;
}

.RechargeApplication-container-1{
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    max-width: 1200px;
}

.RechargeApplication-title-box{
    text-align: center;
}

.RechargeApplication-title-box h1{
    font-size: 32px;
    margin-bottom: 12px;
    color: var(--primary-blue);
}

.RechargeApplication-title-box p{
    width: 100%;
    margin: 0 auto;
    max-width: 650px;
}

.RechargeApplication-pragraph-box{
    margin-top: 30px;
}

.RechargeApplication-pragraph-box p{
    margin: 12px 0;
    list-style: 24px;
}

.RechargeApplication-btn-box{
    gap: 10px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    align-items: center;
}

.RechargeApplication-btn-box button{
    padding: 10px 18px;
    border-radius: 8px;
    transition: 0.3s linear;
}

.RechargeApplication-btn-box button svg{
    font-size: 22px;
}

.RechargeApplication-btn-box button:nth-child(1){
    background-color: var(--primary-green);
}
.RechargeApplication-btn-box button:nth-child(1):hover{
    outline: 3px solid #71f0c4;
}
.RechargeApplication-btn-box button:nth-child(2){
    background-color: #35a9fc;
}
.RechargeApplication-btn-box button:nth-child(2):hover{
    outline: 3px solid #7ac5fb;
}
.RechargeApplication-btn-box button:nth-child(3){
    background-color: #35c0fc;
}
.RechargeApplication-btn-box button:nth-child(3):hover{
    outline: 3px solid #81d9ff;
}


.RechargeApplication-container-2{
    gap: 30px;
    display: flex;
    margin: 3rem 0;
    padding: 40px 30px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.RechargeApplication-left-content{
    flex: 1 1 100%;
}

.RechargeApplication-left-content h3{
    gap: 8px;
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    color: var(--primary-white);
}

.RechargeApplication-left-content h3 svg{
    color: var(--primary-blue);
}

.RechargeApplication-left-content p{
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 3.5rem;
    color: var(--primary-grey2);
}

.RechargeApplication-img-box{
    display: flex;
    flex: 1 1 100%;
    align-items: center;
    justify-content: center;
}

.RechargeApplication-img-box img{
    width: 100%;
    max-width: 650px;
}


.RechargeApplication-container-3{
    padding: 0 20px;
}

.RechargeApplication-top-title-box{
    text-align: center;
}

.RechargeApplication-top-title-box span{
    font-weight: bold;
    color: var(--primary-blue);
}

.RechargeApplication-top-title-box h1{
    font-size: 32px;
    margin: 20px 0 10px 0;
}

.RechargeApplication-content-box{
    gap: 22px;
    display: flex;
    margin-top: 3.5rem;
}

.RechargeApplication-contemt-img-box{
    flex: 1 1 100%;
}

.RechargeApplication-contemt-img-box img{
    width: 100%;
    max-width: 650px;
}

.RechargeApplication-list-box{
    flex: 1 1 100%;
}

.RechargeApplication-list-box li{
    gap: 7px;
    display: flex;
    list-style: none;
    line-height: 38px;
    align-items: center;
}

.RechargeApplication-list-box li svg{
    color: var(--primary-blue);
}

@media (max-width: 1024px){
    .RechargeApplication-container-2,
    .RechargeApplication-content-box{
        flex-direction: column;
    }
    .RechargeApplication-contemt-img-box{
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

@media (max-width: 480px){
    .RechargeApplication-pragraph-box p{
        text-align: justify;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/IT_Service/RechargeApplication/RechargeApplication.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;AAC7B;;;;;AAKA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,SAAS;IACT,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,yDAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;;QAEI,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[":root {\n    --primary-white: #fff;\n    --primary-black: #000;\n    --primary-grey: #73739a;\n    --primary-grey2: #f5f5f5;\n    --primary-blue: #6d72f6;\n    --primary-green: #08ce8a;\n    --primary-black2: #1c1c57;\n}\n\n\n\n\n.RechargeApplication-section{\n    padding: 3rem 0px;\n}\n\n.RechargeApplication-container-1{\n    width: 100%;\n    margin: 0 auto;\n    padding: 0 20px;\n    max-width: 1200px;\n}\n\n.RechargeApplication-title-box{\n    text-align: center;\n}\n\n.RechargeApplication-title-box h1{\n    font-size: 32px;\n    margin-bottom: 12px;\n    color: var(--primary-blue);\n}\n\n.RechargeApplication-title-box p{\n    width: 100%;\n    margin: 0 auto;\n    max-width: 650px;\n}\n\n.RechargeApplication-pragraph-box{\n    margin-top: 30px;\n}\n\n.RechargeApplication-pragraph-box p{\n    margin: 12px 0;\n    list-style: 24px;\n}\n\n.RechargeApplication-btn-box{\n    gap: 10px;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 20px;\n    align-items: center;\n}\n\n.RechargeApplication-btn-box button{\n    padding: 10px 18px;\n    border-radius: 8px;\n    transition: 0.3s linear;\n}\n\n.RechargeApplication-btn-box button svg{\n    font-size: 22px;\n}\n\n.RechargeApplication-btn-box button:nth-child(1){\n    background-color: var(--primary-green);\n}\n.RechargeApplication-btn-box button:nth-child(1):hover{\n    outline: 3px solid #71f0c4;\n}\n.RechargeApplication-btn-box button:nth-child(2){\n    background-color: #35a9fc;\n}\n.RechargeApplication-btn-box button:nth-child(2):hover{\n    outline: 3px solid #7ac5fb;\n}\n.RechargeApplication-btn-box button:nth-child(3){\n    background-color: #35c0fc;\n}\n.RechargeApplication-btn-box button:nth-child(3):hover{\n    outline: 3px solid #81d9ff;\n}\n\n\n.RechargeApplication-container-2{\n    gap: 30px;\n    display: flex;\n    margin: 3rem 0;\n    padding: 40px 30px;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-image: url(./Image/app-bg.webp);\n}\n\n.RechargeApplication-left-content{\n    flex: 1 1 100%;\n}\n\n.RechargeApplication-left-content h3{\n    gap: 8px;\n    display: flex;\n    margin-bottom: 10px;\n    align-items: center;\n    color: var(--primary-white);\n}\n\n.RechargeApplication-left-content h3 svg{\n    color: var(--primary-blue);\n}\n\n.RechargeApplication-left-content p{\n    font-size: 15px;\n    line-height: 22px;\n    margin-bottom: 3.5rem;\n    color: var(--primary-grey2);\n}\n\n.RechargeApplication-img-box{\n    display: flex;\n    flex: 1 1 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.RechargeApplication-img-box img{\n    width: 100%;\n    max-width: 650px;\n}\n\n\n.RechargeApplication-container-3{\n    padding: 0 20px;\n}\n\n.RechargeApplication-top-title-box{\n    text-align: center;\n}\n\n.RechargeApplication-top-title-box span{\n    font-weight: bold;\n    color: var(--primary-blue);\n}\n\n.RechargeApplication-top-title-box h1{\n    font-size: 32px;\n    margin: 20px 0 10px 0;\n}\n\n.RechargeApplication-content-box{\n    gap: 22px;\n    display: flex;\n    margin-top: 3.5rem;\n}\n\n.RechargeApplication-contemt-img-box{\n    flex: 1 1 100%;\n}\n\n.RechargeApplication-contemt-img-box img{\n    width: 100%;\n    max-width: 650px;\n}\n\n.RechargeApplication-list-box{\n    flex: 1 1 100%;\n}\n\n.RechargeApplication-list-box li{\n    gap: 7px;\n    display: flex;\n    list-style: none;\n    line-height: 38px;\n    align-items: center;\n}\n\n.RechargeApplication-list-box li svg{\n    color: var(--primary-blue);\n}\n\n@media (max-width: 1024px){\n    .RechargeApplication-container-2,\n    .RechargeApplication-content-box{\n        flex-direction: column;\n    }\n    .RechargeApplication-contemt-img-box{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 480px){\n    .RechargeApplication-pragraph-box p{\n        text-align: justify;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
